// removed by extract-text-webpack-plugin
module.exports = {"modalWrapper":"src-components-common-ModalLayout-styles__modalWrapper--2rpQt","scrim":"src-components-common-ModalLayout-styles__scrim--1ogXA","modal":"src-components-common-ModalLayout-styles__modal--1OHL3","modalView":"src-components-common-ModalLayout-styles__modalView--DH5eN","imageGallery":"src-components-common-ModalLayout-styles__imageGallery--1gIB5","detailsContainer":"src-components-common-ModalLayout-styles__detailsContainer--1uMMz","alert":"src-components-common-ModalLayout-styles__alert--_wUex","detailsTable":"src-components-common-ModalLayout-styles__detailsTable--2YW6u"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/ModalLayout/styles.scss
// module id = 68
// module chunks = 0